import { collections } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function CollectionSection() {
  return (
    <section id="collections" className="scroll-mt-20 border-b border-background-300/70 bg-background-50">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="COLLECTIONS"
          title="话题合集：把追不完的瓜按主题打包"
          desc="单个话题看不够时，可以顺着合集继续翻。发酵中的、网友整理过的、已经被反转的，各自归档，方便回头补课。"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {collections.map((collection) => (
            <article
              key={collection.title}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-300/70 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="relative h-40 w-full overflow-hidden md:h-44">
                <img
                  src={collection.image}
                  alt={`${collection.title} 合集封面`}
                  title={`${collection.title} - 蝌蚪黑料话题合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded bg-accent-500 px-2 py-1 font-label text-xs font-bold text-accent-950">
                  {collection.badge}
                </span>
                <span className="absolute right-3 top-3 rounded bg-foreground-950/70 px-2 py-1 font-label text-xs text-background-50">
                  {collection.count}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h4 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  <a href="#index" className="cursor-pointer hover:text-primary-700">
                    {collection.title}
                  </a>
                </h4>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{collection.desc}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {collection.topics.map((topic) => (
                    <span
                      key={topic}
                      className="cursor-pointer whitespace-nowrap rounded border border-secondary-200 bg-secondary-100 px-2 py-0.5 font-label text-xs text-secondary-900"
                    >
                      {topic}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}